export default "__VITE_ASSET__DkYH1TPe__"